import type {
  FourthlineProviderDetails,
  KycResponse,
} from '@repo/api-kit/queries/due-diligence/kyc';
import type { KycProviderDetailsContextValue } from '../context/provider-details-context';

export function getFourthlineProviderDetails(
  kycInfo?: KycResponse | null,
  contextProviderDetails?: KycProviderDetailsContextValue | null
): FourthlineProviderDetails | null {
  if (kycInfo?.activeProcess?.providerDetails?.$case === 'fourthlineProviderDetails') {
    return kycInfo.activeProcess.providerDetails.value;
  }
  if (contextProviderDetails?.providerDetails?.$case === 'fourthlineProviderDetails') {
    return contextProviderDetails.providerDetails.value;
  }
  return null;
}
